import { Box } from "@mui/material";
import { DotLegalDialog } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { EntityType } from "@common/Common.types";
import RiskAreaRiskLines from "./RiskAreaRiskLines";
import { RiskAreaHighestRisk } from "./RiskAreaRisks.types";

export interface IRiskAreaRisksDialog {
    riskAreas: Array<RiskAreaHighestRisk>;
    entityType: EntityType;
    entityId: string;
    onClose: () => void;
}

// Read-only list of an entity's linked risk areas, each shown as the same "area name: chip" line as the
// single-area RISK tile, linking to the area's risk assessments overview. Rows keep the backend's worst-first order.
function RiskAreaRisksDialog({ riskAreas, entityType, entityId, onClose }: IRiskAreaRisksDialog) {
    const { translateString } = useTranslation();

    return (
        <DotLegalDialog
            open
            header={translateString("risk")}
            hideOkButton
            buttonOkText={translateString("close")}
            onOkClick={onClose}
            onDialogClose={onClose}
            size="sm"
        >
            <Box sx={{ display: "flex", justifyContent: "center", marginBottom: 2 }}>
                <RiskAreaRiskLines riskAreas={riskAreas} entityType={entityType} entityId={entityId} rowGap={2} />
            </Box>
        </DotLegalDialog>
    );
}

export default RiskAreaRisksDialog;
